import { useQuery, useQueryClient } from '@tanstack/react-query'
import { fetchListNationalities } from 'redux/actions/clientsActions'

const useNationality = () => {
  const queryClient = useQueryClient()

  const queryKey = ['nationalities']

  // Verificar si ya tenemos datos en cache
  const cachedData = queryClient.getQueryData(queryKey)
  const hasValidCache =
    cachedData && !queryClient.getQueryState(queryKey)?.isStale

  const query = useQuery({
    queryKey,
    queryFn: () => fetchListNationalities(),
    staleTime: 1000 * 60 * 30, // 30 minutos
    cacheTime: 1000 * 60 * 60 * 2, // 2 horas
  })

  if (hasValidCache) {
    return {
      data: cachedData,
      isLoading: false,
      isError: false,
      error: null,
    }
  }

  return {
    ...query,
  }
}

export default useNationality
